// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UeZESJ {
  width: 400px;
  height: 200px;
  box-sizing: border-box;
  border: 1px solid #f2f2f2;
  max-width: calc(100vw - 32px);
  padding: 0;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
}

[data-testid='migration-first-recharge-backdrop']:has(.UeZESJ) {
  background: rgba(31, 31, 31, 0.6);
}

.UeZESJ [data-testid\$='-header'] {
  padding: 24px 24px 0;
  min-height: 48px;
  align-items: center;
}

.UeZESJ [data-testid\$='-title'] {
  font-size: 18px;
  font-weight: 500;
  line-height: normal;
}

.UeZESJ [data-testid\$='-close-button'] {
  width: 24px;
  height: 24px;
  flex: none;
  margin-left: 0;
  padding: 0;
}

.UeZESJ [data-testid\$='-body'] {
  flex: 1;
  min-height: 0;
  padding: 16px 24px 24px;
  gap: 16px;
}

.aNtgud {
  flex: 1;
  display: flex;
  align-items: center;
  margin: 0;
  font-family: var(--font-family-base);
  font-size: 14px;
  font-weight: 400;
  color: var(--text-neutral-stronger);
  line-height: 1.6;
}

.vJT1BA {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
}

.vJT1BA button {
  height: 32px;
  min-height: 32px;
  padding: 8px;
  border-width: 1px;
  --size: 14px;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
  border-radius: 4px;
  white-space: nowrap;
}

.F_ERlJ {
  width: 100px;
}

.Cuuegq {
  width: 164px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/HomePageEmissor/components/MigrationFirstRechargeModal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;EAC7B,UAAU;EACV,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":[".modal {\n  width: 400px;\n  height: 200px;\n  box-sizing: border-box;\n  border: 1px solid #f2f2f2;\n  max-width: calc(100vw - 32px);\n  padding: 0;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);\n}\n\n:global([data-testid='migration-first-recharge-backdrop']):has(.modal) {\n  background: rgba(31, 31, 31, 0.6);\n}\n\n.modal :global([data-testid$='-header']) {\n  padding: 24px 24px 0;\n  min-height: 48px;\n  align-items: center;\n}\n\n.modal :global([data-testid$='-title']) {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.modal :global([data-testid$='-close-button']) {\n  width: 24px;\n  height: 24px;\n  flex: none;\n  margin-left: 0;\n  padding: 0;\n}\n\n.modal :global([data-testid$='-body']) {\n  flex: 1;\n  min-height: 0;\n  padding: 16px 24px 24px;\n  gap: 16px;\n}\n\n.description {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--text-neutral-stronger);\n  line-height: 1.6;\n}\n\n.actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 16px;\n}\n\n.actions button {\n  height: 32px;\n  min-height: 32px;\n  padding: 8px;\n  border-width: 1px;\n  --size: 14px;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: normal;\n  border-radius: 4px;\n  white-space: nowrap;\n}\n\n.secondary {\n  width: 100px;\n}\n\n.primary {\n  width: 164px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `UeZESJ`,
	"description": `aNtgud`,
	"actions": `vJT1BA`,
	"secondary": `F_ERlJ`,
	"primary": `Cuuegq`
};
module.exports = ___CSS_LOADER_EXPORT___;
